import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "base-checkbox-group" }
const _hoisted_2 = {
  key: 0,
  class: "label-group"
}
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "mark"
}
const _hoisted_5 = { class: "error-message" }

import { computed, ref, watch } from 'vue';

type CheckboxDirection = 'row' | 'column';
interface CheckboxOption {
  text: string,
  value: any,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckboxGroup',
  props: {
    modelValue: { default: () => [] },
    options: null,
    label: { default: '' },
    errorMessage: { default: '' },
    isRequired: { type: Boolean, default: false },
    hasRule: { type: Boolean, default: false },
    isValidate: { type: Boolean, default: false },
    type: { default: 'column' },
    disabled: { type: Boolean, default: false },
    isObject: { type: Boolean, default: false }
  },
  emits: [
  'update:modelValue',
  'on-change',
  'on-validate'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: any[] | [], options: CheckboxOption[] | string[] | [], label: string, errorMessage: string, isRequired: boolean, hasRule: boolean, isValidate: boolean, type: CheckboxDirection, disabled: boolean, isObject: boolean }



const selfValue = ref<any[]>([]);
const isEmptyFieldError = ref(false);

const errorMessageDisplay = computed(() => {
  if (props.isRequired && selfValue.value.length === 0) {
    return 'At least one item must be selected';
  } else if (props.errorMessage !== undefined && props.errorMessage !== '') {
    return props.errorMessage;
  } else {
    return '';
  }
});

watch(() => props.modelValue, (newValue: any[]) => {
  selfValue.value = [...newValue];
});

function onChange() {
  emit('on-change', selfValue.value);
  if (props.hasRule) {
    emit('on-validate', selfValue.value);
  }
}
function updateModelValue() {
  emit('update:modelValue', selfValue.value);
  if (props.hasRule) {
    emit('on-validate', selfValue.value);
  }
}
function validateEmptyField() {
  if (props.isRequired && selfValue.value.length === 0) {
    isEmptyFieldError.value = true;
  } else {
    isEmptyFieldError.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_va_checkbox = _resolveComponent("va-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label || _unref(errorMessageDisplay))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(__props.label), 1),
          (__props.isRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " * "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.isObject)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`checkbox-${__props.type}`)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
            return (_openBlock(), _createBlock(_component_va_checkbox, {
              key: `checkbox${item.text}${index}`,
              modelValue: selfValue.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((selfValue).value = $event)),
                updateModelValue
              ],
              "array-value": item.value,
              label: item.text,
              class: "mb-2 mr-4",
              disabled: __props.disabled,
              rules: [
          () => _unref(errorMessageDisplay) === '' || '',
        ],
              onChange: onChange,
              "onUpdate:error": validateEmptyField
            }, null, 8, ["modelValue", "array-value", "label", "disabled", "rules"]))
          }), 128))
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(`checkbox-${__props.type}`)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
            return (_openBlock(), _createBlock(_component_va_checkbox, {
              key: `checkbox${item}${index}`,
              modelValue: selfValue.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((selfValue).value = $event)),
                updateModelValue
              ],
              "array-value": item,
              label: item,
              class: "flex mb-2 mr-4",
              disabled: __props.disabled,
              rules: [
          () => _unref(errorMessageDisplay) === '' || '',
        ],
              onChange: onChange,
              "onUpdate:error": validateEmptyField
            }, null, 8, ["modelValue", "array-value", "label", "disabled", "rules"]))
          }), 128))
        ], 2)),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(errorMessageDisplay)), 1)
  ]))
}
}

})